<template>
  <div class="capability-card" :style="cardStyle">
    <h3 class="capability-card__title">{{ title }}</h3>
    <div class="capability-card__img">
      <img :src="image" :alt="title" />
    </div>
    <p class="capability-card__desc">{{ subtitle }}</p>
  </div>
</template>

<script>
export default {
  name: "CapabilityCard",
  props: {
    title: {
      type: String,
      required: true,
    },
    subtitle: {
      type: String,
      required: true,
    },
    image: {
      type: String,
      required: true,
    },
    bgColor: {
      type: String,
      default: "#FBF8F3",
    },
    borderColor: {
      type: String,
      default: "#DDD4C4",
    },
  },
  computed: {
    cardStyle() {
      return {
        backgroundColor: this.bgColor,
        border: `1px solid ${this.borderColor}`,
      };
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/styles/variables.scss";

.capability-card {
  flex: 1;
  border-radius: 16px;
  padding: 22px 22px 40px 22px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 14px;
  overflow: hidden;
  box-sizing: border-box;

  &__title {
    font-family: $font-family;
    font-size: 30px;
    font-weight: 700;
    color: #1a1a1a;
    margin: 0;
    text-align: center;
  }

  &__img {
    width: 100%;
    height: 180px;
    border-radius: 12px;
    overflow: hidden;

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      display: block;
    }
  }

  &__desc {
    font-family: $font-family;
    font-size: 14px;
    font-weight: normal;
    color: #6a6256;
    line-height: 1.72;
    margin: 0;
    text-align: center;
    width: 100%;
  }

  @include mobile {
    &__title {
      font-size: 24px;
    }

    &__img {
      height: 140px;
    }

    &__desc {
      font-size: 13px;
    }
  }
}
</style>
